module.exports = __webpack_public_path__ + "img/truemoney.cdba2da0.png";